import {
  DOCUMENT__EMAIL_FAILURE,
  DOCUMENT__EMAIL_REQUEST,
  DOCUMENT__EMAIL_SUCCESS,
} from '@app/store/actionTypes';
import { DocumentAction } from '@app/store/document/actions';

const initialState = false;

export default function reducer(state: boolean = initialState, action: DocumentAction) {
  switch (action.type) {
    case DOCUMENT__EMAIL_REQUEST:
      return true;
    case DOCUMENT__EMAIL_SUCCESS:
    case DOCUMENT__EMAIL_FAILURE:
      return false;
    default:
      return state;
  }
}
